import "./Classificazione.scss";

export const Classificazione = () => (
  <svg id="uuid-2ff45aa9-70c7-4c3b-aaed-5fcfcd50c993_classificazione" viewBox="0 0 35.09 35.09" className="classificazioneIcon">
    <defs>
      <linearGradient
        id="uuid-9955f62f-b256-4716-8d2e-9c58e03e894d_classificazione"
        x1="0"
        y1="18.48"
        x2="33.22"
        y2="18.48"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#4b78c6" />
        <stop offset="1" stopColor="#2b4281" />
      </linearGradient>
      <linearGradient
        id="uuid-d3bfba04-356f-4cf6-ab25-5ce803808525_classificazione"
        x1="1.86"
        y1="16.61"
        x2="35.09"
        y2="16.61"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#95d0e5" />
        <stop offset="1" stopColor="#009ee3" />
      </linearGradient>
    </defs>
    <g id="uuid-1af31355-1b8d-45a5-b7cc-1eaba423966c_classificazione">
      <path
        className="uuid-9a303f5f-ce72-4be5-ac9e-e525b8fca380"
        d="m31.94,13.44h-9.01c-.71,0-1.28-.57-1.28-1.28V3.15c0-.71-.57-1.28-1.28-1.28h-7.5c-.71,0-1.28.57-1.28,1.28v9.01c0,.71-.57,1.28-1.28,1.28H1.28c-.71,0-1.28.57-1.28,1.28v7.5c0,.71.57,1.28,1.28,1.28h9.01c.71,0,1.28.57,1.28,1.28v9.01c0,.71.57,1.28,1.28,1.28h7.5c.71,0,1.28-.57,1.28-1.28v-9.01c0-.71.57-1.28,1.28-1.28h9.01c.71,0,1.28-.57,1.28-1.28v-7.5c0-.71-.57-1.28-1.28-1.28Z"
      />
      <path
        className="uuid-d3594cf0-cf82-499d-8c8d-4c68c406c17a"
        d="m33.8,11.58h-9.01c-.71,0-1.28-.57-1.28-1.28V1.28c0-.71-.57-1.28-1.28-1.28h-7.5c-.71,0-1.28.57-1.28,1.28v9.01c0,.71-.57,1.28-1.28,1.28H3.15c-.71,0-1.28.57-1.28,1.28v7.5c0,.71.57,1.28,1.28,1.28h9.01c.71,0,1.28.57,1.28,1.28v9.01c0,.71.57,1.28,1.28,1.28h7.5c.71,0,1.28-.57,1.28-1.28v-9.01c0-.71.57-1.28,1.28-1.28h9.01c.71,0,1.28-.57,1.28-1.28v-7.5c0-.71-.57-1.28-1.28-1.28Z"
      />
    </g>
  </svg>
);
